/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_SocialInputs */

const cs_nav_social = /** @type {(inputs: Nav_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sociální sítě`)
};

const en_nav_social = /** @type {(inputs: Nav_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social`)
};

/**
* | output |
* | --- |
* | "Social" |
*
* @param {Nav_SocialInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_social = /** @type {((inputs?: Nav_SocialInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_SocialInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_social(inputs)
	return cs_nav_social(inputs)
});